module.exports = __webpack_public_path__ + "static/CircularStd-Medium-5fb80a48fa4e35d52c78bf940cb3d3f5.ttf";